import customAxios from "../../customAxios";
import { FIND_AREA, FIND_PROVINCE_CITY } from "../../routes";
// import {ADMIN_ALL_SERVICE} from "../../routes";

type Props = {
  provinceId?: string;
};

const findProvinceCity = async (props: Props) => {
  var thisUrl = FIND_PROVINCE_CITY;
  if (props.provinceId) thisUrl += `?id=${props.provinceId}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_AREA: error });
  }
};

export default findProvinceCity;
